import { PDFDocument, rgb } from 'pdf-lib';
import { useEffect, useRef, useState } from 'react';
import { NavLink, withRouter } from 'react-router-dom';
import SignatureCanvas from 'react-signature-canvas';
import SelfPDFViewer from '../../../../components/PDFViewer';

import AlertService from '../../../../components/SweetAlert';
import ToastUtil from '../../../../components/ToastNotification/ToastUtil';
import { config } from '../../../../config/index';
import { DELETE, GET, newFetch, PUT } from '../../../../helpers/fetch';
import LayoutContext from '../../../../store/Layout/contexts';

const EditEsignDocument = ({
  history,
  match: {
    params: { esign_document_id },
  },
}) => {
  const { SERVER_URL } = config;
  const type = localStorage.getItem('type');
  const [status, setStatus] = useState(0);
  const [name, setName] = useState('');
  const [nricFin, setNricFin] = useState('');
  const [salary, setSalary] = useState('');
  const [address, setAddress] = useState('');

  const [tabs, setTabs] = useState([
    {
      title: 'Contract of Service',
      filename: 'cos',
      filepath: `${SERVER_URL}/storage/documents/Contract-of-Service.pdf`,
      signed_filepath: '',
    },
    {
      title: 'Schedule A',
      filename: 'sa',
      filepath: `${SERVER_URL}/storage/documents/Contract-of-Service.pdf`,
      signed_filepath: '',
    },
  ]);
  const [activeTab, setActiveTab] = useState('Contract of Service');

  const [detectError, setDetectError] = useState(false);

  const getFormattedDate = () => {
    const today = new Date();
    const day = String(today.getDate()).padStart(2, '0');
    const month = String(today.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    const year = today.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const [currentDate, setCurrentDate] = useState(getFormattedDate());

  const sigCanvasRef = useRef(null);

  const clearSignature = () => sigCanvasRef.current.clear();

  const fetchEsignDocument = async () => {
    let api_path = `/esign_document/${esign_document_id}`;
    let response = await newFetch(GET, api_path);

    if (response.success) {
      let responseData = response.data;
      setName(responseData.name);
      setNricFin(responseData.nric_fin);
      setStatus(responseData.status);
      setAddress(responseData.address);
      setSalary(responseData.salary);

      const updatedTabs = tabs.map((tab) => {
        if (tab.title === 'Contract of Service') {
          return {
            ...tab,
            signed_filepath: responseData.contract_service
              ? SERVER_URL + '/' + responseData.contract_service
              : '',
          };
        } else if (tab.title === 'Schedule A') {
          return {
            ...tab,
            signed_filepath: responseData.schedule_a
              ? SERVER_URL + '/' + responseData.schedule_a
              : '',
          };
        }

        return tab; // leave others unchanged
      });

      setTabs(updatedTabs);
    }
  };

  const validateForm = () => {
    if (parseInt(name) === 0 || !name) {
      ToastUtil.error('Select client');
      return false;
    }

    if (status === 0) {
      ToastUtil.error('Select status');
      return false;
    }

    if (!salary) {
      ToastUtil.error('Enter salary');
      return false;
    }

    if (!address) {
      ToastUtil.error('Enter Address');
      return false;
    }

    if (!nricFin) {
      ToastUtil.error('Enter last 4 digits of nric');
      return false;
    }

    return true;
  };

  const HandleSubmitUpdate = async (e) => {
    e.preventDefault();
    let addtnl_message = ``;

    if (
      validateForm() &&
      (await AlertService.confirm(
        '',
        `${addtnl_message}Are you sure you want to update this record?`
      ))
    ) {
      let formData = new FormData();

      formData.append('status', status);
      formData.append('name', name);
      formData.append('salary', salary);
      formData.append('address', address);
      formData.append('nric_fin', nricFin);

      let api_path = `/esign_document/${esign_document_id}`;
      let response = await newFetch(PUT, api_path, formData, 'multi');

      ToastUtil.success(response.message);

      if (response.success) {
        history.push(`/esign_document`);
      }
    }
  };

  const handleDeleteEsignDocument = async () => {
    if (
      await AlertService.confirm(
        '',
        'Are you sure you want to delete this document?'
      )
    ) {
      let api_path = `/esign_document/${esign_document_id}`;
      let response = await newFetch(DELETE, api_path);

      ToastUtil.success(response.message);

      response.success && history.push(`/esign_document`);
    }
  };

  const handleSignPdf = async () => {
    const isCanvasEmpty = sigCanvasRef.current.isEmpty();
    if (isCanvasEmpty) {
      ToastUtil.error('Provide a signature before submitting.');
      return;
    }

    tabs.map(async (tab) => {
      // Load base PDF
      const existingPdfBytes = await fetch(tab.filepath).then((res) =>
        res.arrayBuffer()
      );
      const pdfDoc = await PDFDocument.load(existingPdfBytes);
      const pages = pdfDoc.getPages();
      const SecondPage = pages[1];

      // Convert canvas signature to PNG
      const sigDataURL = sigCanvasRef.current
        .getCanvas()
        .toDataURL('image/png');
      const sigImageBytes = await fetch(sigDataURL).then((res) =>
        res.arrayBuffer()
      );
      const pngImage = await pdfDoc.embedPng(sigImageBytes);

      if (tab.title === 'Contract of Service') {
        // Add signature
        SecondPage.drawImage(pngImage, {
          x: 100, //horizontal
          y: 160, //vertical
          width: 150,
          height: 50,
        });

        // Add date
        SecondPage.drawText(currentDate, {
          x: 390, //horizontal
          y: 178, //vertical
          size: 10,
          color: rgb(0, 0, 0),
        });

        // Add name
        SecondPage.drawText(name, {
          x: 100, //horizontal
          y: 145, //vertical
          size: 10,
          color: rgb(0, 0, 0),
        });

        // Add nric
        SecondPage.drawText(nricFin, {
          x: 390, //horizontal
          y: 145, //vertical
          size: 10,
          color: rgb(0, 0, 0),
        });
      } else if (tab.title === 'Schedule A') {
        // Add signature
        SecondPage.drawImage(pngImage, {
          x: 80, //horizontal
          y: 160, //vertical
          width: 150,
          height: 50,
        });

        // Add date
        SecondPage.drawText(currentDate, {
          x: 390, //horizontal
          y: 178, //vertical
          size: 10,
          color: rgb(0, 0, 0),
        });

        // Add name
        SecondPage.drawText(name, {
          x: 100, //horizontal
          y: 145, //vertical
          size: 10,
          color: rgb(0, 0, 0),
        });

        // Add nric
        SecondPage.drawText(nricFin, {
          x: 390, //horizontal
          y: 145, //vertical
          size: 10,
          color: rgb(0, 0, 0),
        });
      }

      // Save and display PDF
      const pdfBytes = await pdfDoc.save();
      const blob = new Blob([pdfBytes], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);
      let api_path = `/esign_document/sign/${esign_document_id}`;
      const formData = new FormData();
      formData.append('type', tab.filename);

      if (tab.title === 'Contract of Service') {
        formData.append('file', blob, `${esign_document_id}_cos_document.pdf`); // name it as needed
        let response = await newFetch(PUT, api_path, formData, 'multi');
        if (response.success) {
          await fetchEsignDocument();
        } else {
          setDetectError(true);
        }
      } else if (tab.title === 'Schedule A') {
        formData.append(
          'file',
          blob,
          `${esign_document_id}_sched_a_document.pdf`
        ); // name it as needed
        let response = await newFetch(PUT, api_path, formData, 'multi');
        if (response.success) {
          await fetchEsignDocument();
          // const updatedTabs = tabs.map((tab2) => {
          //   if (tab2.title === 'Schedule A') {
          //     return {
          //       ...tab2,
          //       signed_filepath:
          //         SERVER_URL + '/' + response.result?.schedule_a || '',
          //     };
          //   } else {
          //     return tab2;
          //   }
          // });
          // setTabs(updatedTabs);
        } else {
          setDetectError(true);
        }
      }
    });

    if (!detectError) {
      ToastUtil.success('Documents have been signed successfully.');
      // clearSignature();
    } else {
      ToastUtil.error(
        'There is an error with signing the documents. Please check your internet or contact the admin.'
      );
    }
  };

  useEffect(() => {
    fetchEsignDocument();
  }, []);

  return (
    <LayoutContext.Consumer>
      {({ activeSidebar }) => {
        return (
          <div style={{ paddingTop: '3rem' }}>
            <div
              className="d-flex flex-column"
              style={{ paddingLeft: '3rem', paddingRight: '3rem' }}
            >
              <NavLink
                to={`/esign_document`}
                className="text-decoration-none"
                style={{ color: 'inherit' }}
              >
                <div style={{ color: '#A6478E' }}>
                  <i className="fas fa-chevron-left pe-2"></i>Back to Documents
                </div>
              </NavLink>
              <div className="pt-4">
                <h5>Edit Document</h5>
              </div>
            </div>

            {status !== 'Completed' && (
              <div
                style={{
                  bottom: 0,
                  width: activeSidebar ? 'calc(100vw - 310px)' : '100vw',
                  height: '4.5rem',
                  paddingRight: '3rem',
                }}
                className="border-top bg-white d-flex align-items-center justify-content-between"
              >
                <button
                  type="button"
                  className="btn btn-danger adjust-fs adjust-shadow ms-4"
                  style={{ width: '12rem' }}
                  onClick={handleDeleteEsignDocument}
                >
                  Delete
                </button>
              </div>
            )}

            <form className="form" onSubmit={(e) => HandleSubmitUpdate(e)}>
              <div
                style={{
                  marginTop: '1rem',
                  paddingLeft: '3rem',
                  paddingRight: '3rem',
                  paddingBottom: '1rem',
                }}
              >
                <div className="d-flex border rounded">
                  <div
                    className="flex-grow-1 bg-white col-md-7"
                    style={{ padding: '2.25rem' }}
                  >
                    <div
                      className="row pb-3 col-md-8"
                      style={{ position: 'relative' }}
                    >
                      <strong>Status</strong>
                      <span
                        className={`badge ${
                          status == 'Pending'
                            ? 'bg-warning'
                            : status == 'Completed'
                            ? 'bg-primary-custom'
                            : 'bg-dark'
                        } adjust-fs adjust-shadow fw-normal`}
                        style={{
                          fontSize: 14,
                          color: '#fff',
                          fontWeight: 200,
                          padding: '6px 17px',
                          width: '150px',
                          position: 'absolute',
                          left: '70px',
                        }}
                      >
                        {status}
                      </span>
                    </div>
                    <div className="row pb-3 col-md-6">
                      <label>
                        <strong>Name</strong>: {name || '-'}
                      </label>
                    </div>
                    <div className="row pb-3 col-md-6">
                      <label>
                        <strong>NRIC</strong>:{' '}
                        {nricFin ? nricFin.replace(/.(?=.{4})/g, 'X') : '-'}
                      </label>
                    </div>
                    <div className="row pb-3 col-md-6">
                      <label>
                        <strong>Salary</strong>: {'-'}
                      </label>
                    </div>
                    <div className="row pb-3 col-md-12">
                      <strong>Address</strong>
                      <label>{address || '-'}</label>
                    </div>
                  </div>
                </div>
              </div>
            </form>

            <div className="d-flex align-items-start">
              <div
                className="d-flex flex-column flex-grow-1"
                style={{
                  marginTop: '1.5rem',
                  marginLeft: '3rem',
                  marginRight: '3rem',
                  marginBottom: '3rem',
                }}
              >
                <div className="d-flex justify-content-start">
                  {tabs.map((tab, index) => (
                    <div
                      key={`1${index}`}
                      className="pb-3 flex-shrink-0"
                      onClick={() => setActiveTab(tab.title)}
                    >
                      <div
                        key={`2${index}`}
                        style={
                          activeTab === tab.title
                            ? {
                                cursor: 'pointer',
                                marginRight: '1.5rem',
                                paddingBottom: '1rem',
                                marginBottom: '1rem',
                                borderBottom: '5px #466ea5 solid',
                              }
                            : {
                                cursor: 'pointer',
                                marginRight: '1.5rem',
                                paddingBottom: '1rem',
                                marginBottom: '1rem',
                              }
                        }
                      >
                        <strong
                          className={
                            activeTab === tab.title
                              ? 'text-brand'
                              : 'text-muted'
                          }
                        >
                          {tab.title}
                        </strong>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="d-flex flex-column">
                  {tabs.map((tab, index) => (
                    <>
                      {activeTab === tab.title && (
                        <>
                          {
                            <div key={`2${index}`}>
                              <SelfPDFViewer
                                file={`${
                                  tab.signed_filepath
                                    ? tab.signed_filepath
                                    : tab.filepath
                                }`}
                                withPageNum={true}
                                controls={true}
                              />
                            </div>
                          }
                        </>
                      )}
                    </>
                  ))}
                </div>
              </div>
            </div>

            <div style={{ width: '600px', margin: '0 auto' }}>
              <div
                style={{
                  width: '600px',
                  height: '200px',
                  border: '#E9E9EF solid 1px',
                  backgroundColor: '#E7E7E7',
                }}
              >
                <SignatureCanvas
                  ref={sigCanvasRef}
                  penColor="black"
                  canvasProps={{
                    width: 600,
                    height: 200,
                    className: 'sigCanvas',
                  }}
                />
              </div>
              <div
                style={{
                  height: '100px',
                  lineHeight: '100px',
                  marginBottom: '50px',
                  position: 'relative',
                }}
              >
                <button
                  type="button"
                  className="btn btn-outline-brand adjust-fs adjust-shadow"
                  style={{
                    width: '12rem',
                    position: 'absolute',
                    left: '0',
                    margin: '20px 0',
                  }}
                  onClick={clearSignature}
                >
                  Clear
                </button>
                <button
                  type="button"
                  className="btn btn-brand ms-3 adjust-fs adjust-shadow"
                  style={{
                    width: '12rem',
                    position: 'absolute',
                    right: '0',
                    margin: '20px 0',
                  }}
                  onClick={handleSignPdf}
                >
                  Sign PDF
                </button>
              </div>
            </div>
          </div>
        );
      }}
    </LayoutContext.Consumer>
  );
};

export default withRouter(EditEsignDocument);
